import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LABEL_BY_PAYMENT_TYPE, PaymentType } from './enums/payment-types.enum';
import { CustomValidators } from '../../../validators/validators';

@Component({
  selector: 'gtd-payment-account',
  templateUrl: './payment-account.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentAccountComponent implements ControlValueAccessor, OnInit {
  public control: UntypedFormControl;
  public dependControl: UntypedFormControl;
  public label = $localize`:@@payment.account:Payment Account`;
  public subscribers: Record<string, Subscription> = {};

  constructor(private cd: ChangeDetectorRef) {}

  public onChange: (value: string) => void = () => {};
  public onTouch = () => {};

  registerOnChange(fn: (value) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(): void {}

  ngOnInit(): void {
    this.subscribers.paymentSystemValueChanges = this.dependControl.valueChanges.subscribe((value) => {
      if (LABEL_BY_PAYMENT_TYPE[value]) {
        this.label = LABEL_BY_PAYMENT_TYPE[value];

        if (value === PaymentType.Neteller || value === PaymentType.Skrill) {
          this.control.addValidators([CustomValidators.email]);
        } else {
          this.control.removeValidators([CustomValidators.email]);
        }

        this.control.updateValueAndValidity();
        this.cd.markForCheck();
      }
    });
  }
}
